import {
    Carousel,
    carouselItem,
    Icon,
    Breadcrumb,
    breadcrumbItem,
    pagination,
    Menu,
    Submenu,
    MenuItem,
  } from "element-ui";

  const element = {
    install: function(Vue) {
        Vue.use(Carousel);
        Vue.use(carouselItem);
        Vue.use(Icon);
        Vue.use(Breadcrumb);
        Vue.use(breadcrumbItem);
        Vue.use(pagination);
        Vue.use(Menu);
        Vue.use(Submenu);
        Vue.use(MenuItem);
    }
}

export default element